import { useState } from 'react'
import Modal from '../../../../components/modal/Modal'
import { Icon } from '@iconify/react'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import FormLoader from '../../../../components/loader/FormLoader'

function ViewOnboardingRequest({
  showRequest,
  setShowRequest,
  fetchOnboardingRequests,
}: any) {
  const [loading, setLoading] = useState(false)
  const { notify } = useGlobalContext()
  const [submitData, setSubmitData] = useState({
    creditLimit: 0,
    role_level: '',
  })

  async function updateRequest(state: string) {
    setLoading(true)
    let data = null
    if (state === 'approve') {
      if (submitData.creditLimit === 0 || submitData.role_level === '') {
        notify('error', 'Please fill all fields')
        setLoading(false)
        return
      }
      data = {
        creditLimit: submitData.creditLimit,
        role_level: submitData.role_level,
      }
    }
    put(`admin/onboarding-request/${state}/${showRequest._id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          setLoading(false)
          notify('success', result.message)
          fetchOnboardingRequests(1)
          setShowRequest(null)
        } else {
          notify('error', result.message)
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <Modal>
      <div className='left-modal'>
        <div className='modal-top flex justify-between items-center'>
          <h2>View Request</h2>
          <div className='close flex items-center justify-center'>
            <Icon icon='line-md:close' onClick={() => setShowRequest(null)} />
          </div>
        </div>
        <div className='modal-content-body'>
          <div className='card'>
            <h4>Date</h4>
            <p>{new Date(showRequest.createdAt).toLocaleDateString()}</p>
          </div>
          <div className='card'>
            <h4>Business name</h4>
            <p>{showRequest.company_name}</p>
          </div>
          <div className='card'>
            <h4>Rep first name</h4>
            <p>{showRequest.firstname}</p>
          </div>
          <div className='card'>
            <h4>Rep last name</h4>
            <p>{showRequest.lastname}</p>
          </div>
          <div className='card'>
            <h4>Phone</h4>
            <p>{showRequest.phonenumber}</p>
          </div>
          <div className='card'>
            <h4>Email</h4>
            <p>{showRequest.email}</p>
          </div>
          <div className='card'>
            <h4>Director ID</h4>
            <a href={showRequest.director_id} target='_blank' rel='noreferrer'>
              <p>view</p>
            </a>
          </div>
          <div className='card'>
            <h4>Business Doc</h4>
            <a href={showRequest.business_doc} target='_blank' rel='noreferrer'>
              <p>view</p>
            </a>
          </div>
          <div className='card'>
            <h4>Email</h4>
            <p>{showRequest.email}</p>
          </div>
          <div className='card'>
            <h4>Website</h4>
            <p>{showRequest.website}</p>
          </div>
          <div className='card'>
            <h4>Company description</h4>
            <p>{showRequest.company_description}</p>
          </div>
          <div className='card'>
            <h4>Intent</h4>
            <p>{showRequest.intent}</p>
          </div>
          <div className='card'>
            <h4>Status</h4>
            <span className={showRequest.status}>{showRequest.status}</span>
          </div>
          {showRequest.status === 'pending' && (
            <form action=''>
              <div className='card'>
                <h4>Credit Limit</h4>
                <input
                  type='number'
                  value={submitData.creditLimit}
                  onChange={(e) =>
                    setSubmitData({
                      ...submitData,
                      creditLimit: parseFloat(e.target.value),
                    })
                  }
                />
              </div>
              <div className='card'>
                <h4>Business Role</h4>
                <select
                  value={submitData.role_level}
                  onChange={(e) =>
                    setSubmitData({ ...submitData, role_level: e.target.value })
                  }
                >
                  <option value=''>-select-</option>
                  <option value='aggregator'>Aggregator</option>
                  <option value='super-aggregator'>Super Aggregator</option>
                  <option value='special'>Special</option>
                  <option value='trusted-user'>Trusted User</option>
                </select>
              </div>
            </form>
          )}
          <div className='card buttons'>
            {loading ? (
              <FormLoader position='center' />
            ) : (
              <>
                {showRequest.status === 'pending' && (
                  <>
                    <button onClick={() => updateRequest('approve')}>
                      Approve
                    </button>
                    <button
                      className='delete'
                      onClick={() => updateRequest('reject')}
                    >
                      Reject
                    </button>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ViewOnboardingRequest
